import React, { useEffect, useState, memo } from "react";
import { HomeCarousel, HomeMobileCarousel, HomeCategories } from "../components/homepage";
import { HomeBannerPlaceholder } from "../components/Common/Placeholders";
import { ProductCategoryFilters, ProductCardPlaceHolder, SubcategoryPlaceHolder } from "../components/placeholders/ProductCategory";
import { Container } from "react-bootstrap";
import { MediaQueries } from "../components/utils";
import { useSelector, useDispatch } from "react-redux";
import { ComponentHeader, ProductCard } from "../components/Common";
import { Row, Col } from "react-bootstrap";
import { NavLink, useParams } from 'react-router-dom';
import { IoCloseOutline } from "react-icons/io5";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSearchParams } from "react-router-dom";
import { Category } from "../actions";
import { sethas_more, setcurrent_page } from "../redux/categoryslice";
import BreadComps from "../components/Common/Breadcomps";
import Modal from 'react-bootstrap/Modal';
import { useLocation } from 'react-router-dom';
import Pricerange from "../components/Common/Pricerange"
import { pushToDataLayer } from "../components/utils/dataUserpush"
const ProductCategory = () => {


    // common page for brands , sub category (mobile-phones) , sub subcategoiry (smart-phones) , search page (search-result) and filters seclected and we share url to others ()

    const dispatch = useDispatch();
    const location = useLocation();
    const segments = location.pathname.split('/');
    const mainCategory = segments[2];
    const categorytype = segments[1]
    const lastTwoSegments = segments.slice(-2).join('/');
    const [show, setShow] = useState(false);
    const [sort_show, setsort_show] = useState(false);
    const [sort_show_desktop, setsort_show_desktop] = useState(false);
    const [show_filters, setshow_filters] = useState(false);

    // Getting category-related redux state data
    const { getSubCatScreenList, filtered_items } = Category();
    const subcategoryScreen = useSelector(state => state.categoryslice.subcategoryScreen);
    const displayed_products = useSelector(state => state.categoryslice.displayed_products);
    const catloading = useSelector(state => state.categoryslice.catloading);
    const categorydata = useSelector((state) => state.globalslice.data);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    const has_more = useSelector(state => state.categoryslice.has_more);
    const initial_page = useSelector(state => state.categoryslice.initial_page);
    const categoryList = useSelector(state => state.globalslice.data);
    const categoryloading = useSelector(state => state.globalslice.loading);


    // Getting URL params and slug values
    const [urlParams, setUrlParams] = useSearchParams();
    const { slug, slug1, slug2 } = useParams();


    // State to manage categories and filters locally
    const [catdata, setcatdata] = useState([])
    const [subcatdatass, setsubcatselected] = useState()
    const [subsubcategory, setsubsubcategory] = useState()
    const [searchInputs, setSearchInputs] = useState({});



    // Functions to open and close modals
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleShowSort = () => {
        setsort_show(!sort_show)
    }


    useEffect(() => {

        // breadcomp logic starts here getting breadcomp links and titles from categorydata redux state for subcategiry and subsubcategory pages
        if (!categorydata?.length || !mainCategory) return;

        const matchedData = categorydata.filter(category =>
            category.subcategory?.some(sub => sub.url === mainCategory)
        );

        setcatdata(matchedData)
        const matchedSubcategory = matchedData[0]?.subcategory?.find(sub => sub.url === mainCategory);

        if (matchedSubcategory) {
            setsubcatselected({
                title: matchedSubcategory.sub_category_name,
                url: matchedSubcategory.url,
                id: matchedSubcategory.sub_category_id,
                data: matchedSubcategory
            });
        }

        if (categorytype === "products-category") {
        } else {
            const subcatdata = matchedData[0]?.subcategory?.filter(ele =>
                ele.sub_subcategory?.some(sub => sub.url === lastTwoSegments)
            );

            subcatdata?.forEach(({ sub_subcategory }) => {
                const match = sub_subcategory.find(({ url }) => url === lastTwoSegments);
                if (match) {
                    setsubsubcategory(match.sub_subcategory_name);
                }
            });
        }

        // ends here
    }, [categorydata, mainCategory, categorytype, lastTwoSegments]);



    useEffect(() => {
        // wheen new slug like mobile-phones to mobile-tablets this dependency
        dispatch(sethas_more(true)) // resetting to true if slug changed
        dispatch(setcurrent_page(1)) // resetting to 1 if slug changed

        // getting values from url params /Pre-Owned-Mobiles?Colors=Gray%2CSilver&Brands=Nokia&min=65&max=458
        var queryObj = {};
        for (const entry of urlParams.entries()) {
            queryObj = Object.fromEntries([...urlParams]);
        }

        var finalInput = Object.entries(queryObj).map(([key, value]) => ({
            title: key,
            value: value.split(",").map((ele) => ele),
        }))

        if (finalInput.length > 0) {
            setshow_filters(true)
        }

        setselected_items(finalInput.map(ele => ele.value).flat()) // storing values in array not array of object
        var input_data = {
            "page": 1,
            "finalInput": finalInput,
            "slug": slug, // here slug can be mobile-phones,mobile-tablets 
            "slug1": slug1, // here slug1 can be apple/205 samsung/208 
        }
        // calling api because we need filters initiall api will called and this method has lot of apis inside this method like brands api subcategoiry subsucategoiry api search result api based on window.location.pathname
        getSubCatScreenList(input_data)
    }, [slug, slug2])

    const sort_byArray = [
        {
            id: 1,
            title: 'New Arrivals',
            slug: 'new arrival'
        },
        {
            id: 2,
            title: 'Low to High Price',
            slug: 'Low to High'
        },
        {
            id: 3,
            title: 'High to Low Price',
            slug: 'High to Low'
        },
        {
            id: 4,
            title: 'Position',
            slug: 'Position'
        }
    ]


    const { isMobile } = MediaQueries()


    const [selected, selected_filters] = useState([]);
    const [mobile_selected, mobile_selected_filters] = useState(0);
    const [limited_items, setlimited_items] = useState([]);
    const [selected_items, setselected_items] = useState([]);

    const handleSelectFilter = (id) => {
        if (selected.includes(id)) {
            selected_filters(selected.filter(ele => ele != id))
        } else {
            selected_filters([...selected, id])
        }
        if (limited_items.includes(id)) {
            setlimited_items(limited_items.filter(ele => ele != id))
        }
    }

    const handleMobileSelectFilter = (id) => {
        mobile_selected_filters(id)
    }

    const handleSelectItem = (event, id, item) => {
        // checkbox select on fiulters calling same api for dropdodown sort by and checkboxes
        dispatch(setcurrent_page(1))
        dispatch(sethas_more(true))

        event.stopPropagation()
        const splitted_value = item.value.split('@')

        if (id == 'sortby') {
            if (selected_items.some(value => sort_byArray.map(({ slug }) => slug).flat().includes(value))) {
                const ismatchedvalue = selected_items.filter(value => sort_byArray.map(({ slug }) => slug).flat().includes(value))
                setselected_items([...selected_items.filter(ele => ele != ismatchedvalue), splitted_value[0]])
                urlParams.set(splitted_value[1], splitted_value[0]);
                setUrlParams(urlParams);
            } else {
                setselected_items(
                    [...selected_items, splitted_value[0]])
                urlParams.set(splitted_value[1], splitted_value[0]);
                setUrlParams(urlParams);
            }
            setsort_show(false)
        } else {
            if (selected_items.includes(splitted_value[0])) {
                setselected_items(
                    selected_items.filter(ele => ele != splitted_value[0])
                )
                const ParamsValue = urlParams.get(splitted_value[1]);
                const paramsArray = ParamsValue.split(",");

                const UrlArray = paramsArray.filter(ele => ele !== splitted_value[0]);
                urlParams.set(splitted_value[1], UrlArray.toString());

                if (UrlArray.length <= 0) {
                    urlParams.delete(splitted_value[1]);
                }
            } else {
                setselected_items(
                    [...selected_items.filter(ele => ele != splitted_value[0]), splitted_value[0]])
                if (urlParams.has(id)) {
                    const ParamsValue = urlParams.get(splitted_value[1]);
                    urlParams.delete(ParamsValue);
                    urlParams.set(splitted_value[1], ParamsValue + "," + splitted_value[0]);
                } else {
                    urlParams.set(splitted_value[1], splitted_value[0]);
                }
            }
        }

        if (!isMobile) {
            setUrlParams(urlParams);
        }

    }

    const handleSelectedAll = (event, id) => {
        event.stopPropagation()
        if (limited_items.includes(id)) {
            setlimited_items(limited_items.filter(ele => ele != id))
        } else {
            setlimited_items([...limited_items, id])
        }
    }


    useEffect(() => {
        if (!catloading) {

            // this section is for selected filters will be shown abover the products like grey,blue,yellow,256gb,4gb ram 
            var queryObj = {};
            for (const entry of urlParams.entries()) {
                queryObj = Object.fromEntries([...urlParams]);
            }

            var finalInput = Object.entries(queryObj).map(([key, value]) => ({
                title: key,
                value: value.split(",").map((ele) => ele),
            }))

            if (finalInput.length > 0) {
                selected_filters([...finalInput.filter(({ title }) => title == 'subsubcategory').map(ele => ele.value).flat().map(item => parseInt(item.split("_")[1])), ...finalInput.filter(({ title }) => title != 'subsubcategory').map(ele => ele.title).flat()])
            } else {
                selected_filters([...subcategoryScreen.filters.categories.slice(0, 1).map(({ sub_category_id }) => sub_category_id), ...subcategoryScreen.filters.checkbox.slice(0, 2).map(({ title }) => title)])
            }

        }
    }, [catloading])


    useEffect(() => {
        // commoen dependency for search result and brnads and suibcategiory filters
        if (subcatdatass != undefined || window.location.pathname.split("/")[1] == 'search-result' || window.location.pathname.split("/")[1] == 'brands') {
            dispatch(setcurrent_page(1))
            var queryObj = {};
            for (const entry of urlParams.entries()) {
                queryObj = Object.fromEntries([...urlParams]);
            }

            var finalInput = Object.entries(queryObj).map(([key, value]) => ({
                title: key,
                value: value.split(",").map((ele) => ele.split("_")[0]),
            })).filter(({ title }) => title != 'min' && title != 'max')

            var SearchInput = Object.entries(queryObj).map(([key, value]) => ({
                title: key,
                value: value.split(",").map((ele) => ele.split("_")[0]),
            })).filter(({ title }) => title != 'subcategory')

            const matched = Object.entries(queryObj).reduce((acc, [key, value]) => {
                if (key === 'min' || key === 'max') {
                    acc[key] = [value];
                }
                return acc;
            }, {});

            const priceInput = Object.keys(matched).length ? [matched] : [];

            if (window.location.pathname.split("/")[1] == 'search-result' && SearchInput.length < 1) {
                // u have to call this api else you will not get filters  initially
                var input_data = {
                    "page": 1,
                    "finalInput": finalInput,
                    "slug": slug,
                    "slug1": slug1

                }
                getSubCatScreenList(input_data)
            }


            if (finalInput.length > 0 || priceInput.length > 0) {

                if (window.location.pathname.split("/").includes('brands')) {
                    var input_data = {
                        "page": initial_page,
                        "filtered_items": [{ title: 'brands', value: [slug] }, ...finalInput],
                        ...(priceInput.length > 0 && { price_range: priceInput })
                    }
                    filtered_items(input_data)
                } else if (window.location.pathname.split("/").includes('search-result')) {

                    var input_data = {
                        "page": initial_page,
                        "filtered_items": finalInput,
                        "searchString": slug,
                        ...(priceInput.length > 0 && { price_range: priceInput }),
                        "subcategory_id": 'search'
                    }
                    filtered_items(input_data)
                } else {
                    // we have to pass subcategory id for filters api like this we are feth from categirylist redux state {title: "subcategory", value: [290]}
                    var sub_cat_aray = finalInput.filter(({ title }) => title == 'subsubcategory' || title == 'subcategory')
                    if (sub_cat_aray.length > 0) {
                        var arr = []
                    } else {
                        if (subcatdatass != undefined) {
                            if (slug1 != undefined) {
                                // products-subcategory/Laptops/Gaming-Laptops for filter api you need to pass this id
                                var data = subcatdatass.data.sub_subcategory
                                    .find(({ url }) => url.split("/")[1] == slug1);
                                var arr = [
                                    {
                                        title: 'subsubcategory',
                                        value: [data.sub_subcategory_id]
                                    }
                                ]

                            } else {
                                // products-category/Laptops for filter api you need to pass this id
                                var arr = [
                                    {
                                        title: 'subcategory',
                                        value: [subcatdatass.id]
                                    }
                                ]
                            }

                        } else {
                            var arr = []
                        }

                    }
                    var input_data = {
                        "page": initial_page,
                        "filtered_items": [...finalInput, ...arr],
                        ...(priceInput.length > 0 && { price_range: priceInput })

                    }
                    filtered_items(input_data) // calling filter api
                }



            } else {
                var input_data = {
                    "page": 1,
                    "finalInput": finalInput,
                    "slug": slug,
                    "slug1": slug1
                }
                getSubCatScreenList(input_data)
            }
        }
        // here dependencies are location.pathname if user click on filter checkbox here will come 
        // subcatdatass v need to paas subcategiry for filters api so we need this dependency
        // urlParams if when we click on filters checkbox we pushing value to the url params so v added here dependencuy
        // location.pathname if you go search-result/Apple and brands/Apple both have same slugs sdo we using location.pathname 
    }, [slug, location.pathname, urlParams, subcatdatass])


    var fetchTitle = (item) => {
        // v only passing value to the url but v need title for the selected filters list which we are showing in the above products so use this functionto fetch title from the based on id
        var queryObj = {};
        for (const entry of urlParams.entries()) {
            queryObj = Object.fromEntries([...urlParams]);
        }

        var finalInput = Object.entries(queryObj).map(([key, value]) => ({
            title: key,
            value: key == 'subsubcategory' || key == 'subcategory' ? value.split(",").map((ele) => ele) : value.split(",").map((ele) => ele.split("_")[0]),
        }))

        return finalInput.map(ele => {
            if (ele.value.includes(item)) {
                return {
                    title: ele.title,
                    value: item
                }
            }
        }).filter(remove_undefined => remove_undefined != undefined)
    }

    const deleteItem = (item) => {
        // if we remove selected filter
        dispatch(setcurrent_page(1))
        dispatch(sethas_more(true))
        var value = fetchTitle(item)

        setselected_items(selected_items.filter(ele => ele != item))

        const ParamsValue = urlParams.get(value[0].title);
        var paramsArray = ParamsValue.split(",");
        var filteredArray = paramsArray.filter((ele) => ele !== value[0].value);
        urlParams.set(value[0].title, filteredArray.toString());
        if (filteredArray.length <= 0) {
            urlParams.delete(value[0].title);
        }
        setUrlParams(urlParams);

    }

    const clear_all = async () => {

        var queryObj = {};
        for (const entry of urlParams.entries()) {
            queryObj = Object.fromEntries([...urlParams]);
        }

        var finalInput = Object.entries(queryObj).map(([key, value]) => ({
            title: key,
        }))

        finalInput.map(ele => {
            urlParams.delete(ele.title);
            urlParams.delete('subsubcategory');
        })

        setUrlParams(new URLSearchParams(urlParams)); // Ensure immutability
        setselected_items([]); // Call after loop is completed
        handleClose();
    }

    const apply_all = async () => {
        setUrlParams(urlParams);
        if (selected_items.length > 0) {
            setshow_filters(true)
        }
        handleClose();
    }
    const pathname = window.location.pathname; // "/categories/Laptops-Computers"
    const lastSegment = pathname.split('/').pop(); // "Laptops-Computers"


    useEffect(() => {
        let eventData = {};

        if (categorytype === "products-category") {
            eventData = {
                subcategory_name: subcatdatass?.title,
            };
        } else if (categorytype === "products-subcategory") {
            eventData = {
                subcategory2_name: subsubcategory,
            };
        }

        pushToDataLayer("viewed_category_page", currentcountry.name, eventData);
    }, []);

    const [openCategory, SetOpenCategory] = useState(true)

    const handleCategoryToggle = () => {
        SetOpenCategory(!openCategory)
    }

    return (
        <>
            <Container fluid className="pt-2 pb-3">

                {
                    !isMobile && (
                        categorytype === "products-category" ? (
                            <BreadComps
                                title0={catdata[0]?.category_name}
                                link0={catdata[0]?.url}
                                activetitle={subcatdatass?.title}
                            />
                        ) : categorytype === "products-subcategory" ? (
                            <BreadComps
                                title0={catdata[0]?.category_name}
                                link0={catdata[0]?.url}
                                title1={subcatdatass?.title}
                                link1={subcatdatass?.url}
                                activetitle={subsubcategory}
                            />
                        ) : null
                    )
                }


                <Row className='mt-3'>
                    <Col lg={3} className="desktop_filters">
                        {
                            !isMobile &&
                            <>
                                <h5 className="filter_cat_heading">Filters</h5>
                                {
                                    (!catloading) ?
                                        <>

                                            <div onClick={handleCategoryToggle} className="cursor-pointer d-flex align-items-center mb-3" style={{ justifyContent: "space-between", marginBottom: "10px" }}>
                                                <h5 className="mb-0 catgeory_Section_heading" >Category</h5>
                                                {
                                                    openCategory ?
                                                        <img src='/assets/vector_icons/arrow_up.png' />
                                                        :
                                                        <img src='/assets/vector_icons/arrow_down.png' />

                                                }
                                            </div>
                                            {
                                                openCategory &&
                                                <div className="border-bottom pb-3 mb-3">
                                                    {

                                                        subcategoryScreen.filters.categories.map((cat) => {
                                                            return (
                                                                <div className="filter_cat" onClick={() => handleSelectFilter(cat.sub_category_id)}>
                                                                    <div className="d-flex align-items-center" style={{ justifyContent: "space-between", marginBottom: "12px" }}>
                                                                        <h5 className="mb-0">{cat.label}</h5>
                                                                        {
                                                                            selected.includes(cat.sub_category_id) ?
                                                                                <img src='/assets/vector_icons/arrow_up.png' />
                                                                                :
                                                                                <img src='/assets/vector_icons/arrow_down.png' />

                                                                        }
                                                                    </div>
                                                                    {
                                                                        selected.includes(cat.sub_category_id) && cat.children.map((child) => {
                                                                            return (
                                                                                <div className="filter_item px-2" onClick={(e) => handleSelectItem(e, 'subsubcategory', child)}>
                                                                                    <div>
                                                                                        <input type='checkbox' defaultChecked={selected_items.includes(child.value.split('@')[0]) ? true : false} key={selected_items.includes(child.value.split('@')[0]) ? true : false} />
                                                                                    </div>
                                                                                    <span>{child.label}</span>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }



                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }

                                            {
                                                subcategoryScreen.filters.slider_range.length > 0 &&
                                                <Pricerange urlParams={urlParams} setUrlParams={setUrlParams}

                                                    currency={currentcountry.currency} max_value={subcategoryScreen.filters.slider_range[0].max_value} min_value={subcategoryScreen.filters.slider_range[0].min_value} />
                                            }

                                            {
                                                subcategoryScreen.filters.checkbox.map((cat) => {
                                                    const isSelected = selected.includes(cat.title);
                                                    const searchValue = searchInputs[cat.title] || '';

                                                    // Filter list based on search with null checks
                                                    const filteredList = isSelected && Array.isArray(cat.list)
                                                        ? cat.list.filter(child =>
                                                            child?.name?.toLowerCase().includes(searchValue)
                                                        )
                                                        : [];

                                                    const visibleList = limited_items.includes(cat.title)
                                                        ? filteredList
                                                        : filteredList.slice(0, 5);

                                                    return (
                                                        <div className="filter_cat pb-4 border-bottom" key={cat.title}>
                                                            {/* Clickable Category Header */}
                                                            <div
                                                                className="d-flex align-items-center mb-3"
                                                                style={{
                                                                    justifyContent: "space-between",
                                                                    marginBottom: "10px",
                                                                    cursor: "pointer"
                                                                }}
                                                                onClick={() => handleSelectFilter(cat.title)}
                                                            >
                                                                <h5 className="mb-0 catgeory_Section_heading">{cat.title}</h5>
                                                                <img
                                                                    src={
                                                                        isSelected
                                                                            ? "/assets/vector_icons/arrow_up.png"
                                                                            : "/assets/vector_icons/arrow_down.png"
                                                                    }
                                                                    alt="arrow"
                                                                />
                                                            </div>

                                                            {/* Search Input */}
                                                            {isSelected && (
                                                                <div className="search-wrapper mb-2">
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Search"
                                                                        className="filtersearch"
                                                                        value={searchInputs[cat.title] || ""}
                                                                        onChange={(e) => {
                                                                            e.stopPropagation();
                                                                            setSearchInputs({
                                                                                ...searchInputs,
                                                                                [cat.title]: e.target.value.toLowerCase()
                                                                            });
                                                                        }}
                                                                    />
                                                                    <img src="/assets/vector_icons/filtersearch.png" alt="Search" className="search-icon" />
                                                                </div>
                                                            )}
                                                            {/* Filtered Items */}
                                                            {isSelected &&
                                                                visibleList.map((child) => (
                                                                    <div
                                                                        className="filter_item px-2"
                                                                        key={child.name}
                                                                        onClick={(e) =>
                                                                            handleSelectItem(e, cat.title, {
                                                                                value: `${child.name}@${cat.title}`,
                                                                            })
                                                                        }
                                                                    >
                                                                        <div>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selected_items.includes(child.name)}
                                                                                readOnly
                                                                            />
                                                                        </div>
                                                                        <span>{child.name}</span>
                                                                    </div>
                                                                ))}

                                                            {/* See All / See Less */}
                                                            {isSelected && filteredList.length > 8 && (
                                                                <h6
                                                                    className="see_all_link"
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        handleSelectedAll(event, cat.title);
                                                                    }}
                                                                >
                                                                    {limited_items.includes(cat.title) ? "See less" : "See all"}
                                                                </h6>
                                                            )}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </>
                                        :
                                        <ProductCategoryFilters />
                                }
                            </>
                        }
                    </Col>
                    <Col lg={9}>
                        <Row >
                            {
                                !window.location.pathname.split("/").includes('search-result') && ((!catloading && subcategoryScreen.display_items.hasOwnProperty("banners")) ? (isMobile ?
                                    <HomeMobileCarousel carousel_data={subcategoryScreen.display_items.banners} />
                                    :
                                    <HomeCarousel carousel_data={subcategoryScreen.display_items.banners} />
                                ) : <HomeBannerPlaceholder height={isMobile ? 125 : 250} />
                                )
                            }
                            <div className="mt-5"></div>
                            {
                                (slug1 == undefined && !window.location.pathname.split("/").includes('brands') && !window.location.pathname.split("/").includes('search-result')) && (!categoryloading ?
                                    <div className="component_1 cat_carousel">
                                        <ComponentHeader title={'Shop by Sub-Categories'} view_all={'rgba(82, 50, 194, 1)'} />
                                        <HomeCategories category_list={categoryList.map(item => item.subcategory).flat().filter(({ url }) => url == slug)[0].sub_subcategory} type={slug1 == undefined ? 5 : 3} />
                                    </div>
                                    :
                                    <>
                                        {
                                            [1, 2, 3, 4, 5, 6].map((product) => {
                                                return (
                                                    <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6} className="mb-4">
                                                        <SubcategoryPlaceHolder />
                                                    </Col>
                                                )
                                            })
                                        }
                                    </>)
                            }

                            <div className="mt-4"></div>

                            <div className="comaplete_row">
                                <div>
                                    {
                                        (!catloading) && (isMobile && show_filters || !isMobile) &&
                                        <>
                                            <div className="filters_delete mb-3">
                                                {
                                                    selected_items.map((item) => {
                                                        if (window.location.pathname.split("/").includes('search-result')) {
                                                            var data = subcategoryScreen.filters.categories.filter(ele => ele.category_id == item.split("_")[1]).map(({ children }) => children).flat();
                                                        } else {
                                                            var data = subcategoryScreen.filters.categories.filter(ele => ele.sub_category_id == item.split("_")[1]).map(({ children }) => children).flat().filter(({ sub_subcategory_id }) => sub_subcategory_id == item.split("_")[0])
                                                        }

                                                        return (
                                                            <div className="delete_row mb-2" onClick={() => deleteItem(item)}>
                                                                <h5 className="mb-0 me-2">{data.length > 0 ? data[0].label : item}</h5>
                                                                <IoCloseOutline color="#000" size={18} />
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </>
                                    }
                                </div>
                                {
                                    !isMobile &&

                                    // desktop sort by dropdown starts here
                                    <div className="sort_by_Desktop mb-3" style={{ justifyContent: "flex-end" }}>
                                        <h5>Sort by</h5>
                                        <div>
                                            <div className="d-flex dropdown_title" onClick={() => setsort_show_desktop(!sort_show_desktop)}>
                                                <h5 className="mb-0">{selected_items.filter(value => sort_byArray.map(({ slug }) => slug).flat().includes(value)) != '' ? selected_items.filter(value => sort_byArray.map(({ slug }) => slug).flat().includes(value)) : sort_byArray[0].title}</h5>
                                                <img src='/assets/vector_icons/arrow_down.png' width={20} height={20} />
                                            </div>
                                            {
                                                sort_show_desktop &&
                                                <div className="sort_by_dropdown">
                                                    {
                                                        sort_byArray.map((child) => {
                                                            return (
                                                                <h6 className={`mb-2 ${selected_items.includes(child.slug) && 'primarycolor'}`} style={{ fontWeight: selected_items.includes(child.slug) ? 600 : 400 }} onClick={(e) => {
                                                                    setsort_show_desktop(!sort_show_desktop)
                                                                    handleSelectItem(e, 'sortby', { value: child.slug + "@" + 'sortby' })
                                                                }}>{child.title}</h6>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }

                                        </div>
                                    </div>
                                }

                            </div>





                            {
                                (!catloading) ?
                                    (
                                        displayed_products.length > 0 ?
                                            <InfiniteScroll

                                                dataLength={displayed_products.length}
                                                next={() => {
                                                    // infinte scroll updating page everytime and calling filters api beacause filters api is common for all pages
                                                    dispatch(setcurrent_page(initial_page + 1))

                                                    var queryObj = {};
                                                    for (const entry of urlParams.entries()) {
                                                        queryObj = Object.fromEntries([...urlParams]);
                                                    }

                                                    var finalInput = Object.entries(queryObj).map(([key, value]) => ({
                                                        title: key,
                                                        value: value.split(",").map((ele) => ele.split("_")[0]),
                                                    })).filter(({ title }) => title != 'min' && title != 'max')

                                                    if (finalInput.length > 0) {

                                                        if (window.location.pathname.split("/")[1] == 'search-result') {
                                                            var arr = []
                                                        } else {
                                                            if (slug1 != undefined) {
                                                                var data = subcatdatass.data.sub_subcategory
                                                                    .find(({ url }) => url.split("/")[1] == slug1);
                                                                var arr = [
                                                                    {
                                                                        title: 'subsubcategory',
                                                                        value: [data.sub_subcategory_id]
                                                                    }
                                                                ]

                                                            } else {
                                                                var arr = [
                                                                    {
                                                                        title: 'subcategory',
                                                                        value: [subcatdatass.id]
                                                                    }
                                                                ]
                                                            }
                                                        }

                                                        var input_data = {
                                                            "page": initial_page + 1,
                                                            "filtered_items": [...finalInput, ...arr]
                                                        }
                                                        filtered_items(input_data)
                                                    } else {
                                                        if (window.location.pathname.split("/").includes('brands')) {
                                                            var input_data = {
                                                                "page": initial_page + 1,
                                                                "filtered_items": [{ title: 'brands', value: [slug] }]
                                                            }
                                                            filtered_items(input_data)
                                                        } else if (window.location.pathname.split("/").includes('search-result')) {
                                                            var input_data = {
                                                                "page": initial_page + 1,
                                                                "filtered_items": finalInput,
                                                                "searchString": slug,
                                                                "subcategory_id": "search"
                                                            }
                                                            filtered_items(input_data)
                                                        } else {
                                                            var input_data = {
                                                                "page": initial_page + 1,
                                                                "finalInput": [],
                                                                "slug": slug,
                                                                "slug1": slug1

                                                            }
                                                            getSubCatScreenList(input_data)
                                                        }

                                                    }
                                                    // dispatch({ type: 'setFilterPage', payload: filterPage + 1 })
                                                }}
                                                hasMore={has_more}
                                                scrollThreshold={"80%"}
                                                loader={
                                                    displayed_products.length >= 50 &&
                                                    <div style={{ textAlign: "center" }}>
                                                        <img src='https://www.ourshopee.com/static/media/loader.b7845d8936c686dc2914.gif' />
                                                    </div>
                                                }
                                                // endMessage={<></>}
                                                // refreshFunction={refresh}
                                                style={{ overflow: "hidden" }}
                                            >
                                                <Row className='mb-4 gx-2 gy-2'>
                                                    {
                                                        displayed_products.map((product) => {
                                                            return (
                                                                <Col xxl={3} xl={3} lg={3} md={3} sm={6} xs={6}>
                                                                    <NavLink to={`/details/${product.url}/${product.sku}`} className={'text-decoration-none'}>
                                                                        <ProductCard item={product} />
                                                                    </NavLink>
                                                                </Col>
                                                            )
                                                        })
                                                    }

                                                </Row>

                                            </InfiniteScroll>
                                            :
                                            <div className="d-flex align-items-center justify-content-center"><h4>no record found</h4></div>
                                    )
                                    :

                                    [1, 2, 3, 4, 5].map((product) => {
                                        return (
                                            <Col xxl={3} xl={3} lg={3} md={3} sm={6} xs={6} className="mb-4">
                                                <ProductCardPlaceHolder />
                                            </Col>
                                        )
                                    })


                            }
                        </Row>


                    </Col>
                </Row>

                {/* mobile filters starts here */}
                <Modal show={show} className="mobile_filter_modal" onHide={handleClose} fullscreen>
                    <div className="filter_header border-bottom p-3">
                        <h4 className="mb-0 mt-0">Filters</h4>
                        <img src='/assets/vector_icons/close.png' width={16} height={16} onClick={handleClose} />
                    </div>
                    <Modal.Body className="modal_body p-0">

                        <div className="modal_filter_body">

                            <div className="modal_filter_body_left_side">
                                {
                                    (!catloading) &&
                                    <>
                                        {
                                            subcategoryScreen.filters.categories.map((cat) => {
                                                return (
                                                    <div className={`filter_cat ${mobile_selected == cat.sub_category_id && 'border_left_active'}`} onClick={() => handleMobileSelectFilter(cat.sub_category_id)} style={{ background: mobile_selected == cat.sub_category_id && '#fff' }}>
                                                        <h5 className={`mb-0 mx-2 ${mobile_selected == cat.sub_category_id && 'primarycolor font-weight-600'}`} >{cat.label}</h5>
                                                        {
                                                            mobile_selected == cat.sub_category_id ?
                                                                <img src='/assets/vector_icons/arrow_up_2.png' className="mb-0 mx-2" style={{ width: '15px', height: '15px' }} />
                                                                :
                                                                <img src='/assets/vector_icons/arrow_down.png' className="mb-0 mx-2" style={{ width: '15px', height: '15px' }} />
                                                        }
                                                    </div>
                                                )
                                            })
                                        }

                                        {
                                            subcategoryScreen.filters.checkbox.map((cat) => {
                                                return (
                                                    <div className={`filter_cat ${mobile_selected == cat.title && 'border_left_active'}`} onClick={() => handleMobileSelectFilter(cat.title)} style={{ background: mobile_selected == cat.title && '#fff' }}>
                                                        <h5 className="mb-0 mx-2 catgeory_Section_heading">{cat.title}</h5>
                                                        {
                                                            mobile_selected == cat.title ?
                                                                <img src='/assets/vector_icons/arrow_up_2.png' className="mb-0 mx-2" style={{ width: '15px', height: '15px' }} />
                                                                :
                                                                <img src='/assets/vector_icons/arrow_down.png' className="mb-0 mx-2" style={{ width: '15px', height: '15px' }} />

                                                        }

                                                    </div>
                                                )
                                            })
                                        }







                                    </>
                                }
                            </div>

                            <div className="modal_filter_body_right_side">
                                {

                                    (!catloading) && subcategoryScreen.filters.categories.filter(ele => ele.sub_category_id == mobile_selected).length > 0 && subcategoryScreen.filters.categories.filter(ele => ele.sub_category_id == mobile_selected)[0].children.map((child) => {
                                        return (
                                            <div className="filter_item px-2" onClick={(e) => handleSelectItem(e, 'subsubcategory', child)}>
                                                <h6 className="mb-0 mt-0" style={{ fontWeight: 400 }}>{child.label}</h6>
                                                <input type='checkbox' defaultChecked={selected_items.includes(child.value.split('@')[0]) ? true : false} key={selected_items.includes(child.value.split('@')[0]) ? true : false} />
                                            </div>
                                        )
                                    })
                                }
                                {

                                    (!catloading) && subcategoryScreen.filters.checkbox.filter(ele => ele.title == mobile_selected).length > 0 && subcategoryScreen.filters.checkbox.filter(ele => ele.title == mobile_selected)[0].list.map((child) => {
                                        return (
                                            <div className="filter_item px-2" onClick={(e) => handleSelectItem(e, subcategoryScreen.filters.checkbox.filter(ele => ele.title == mobile_selected)[0].title, { value: child.name + "@" + subcategoryScreen.filters.checkbox.filter(ele => ele.title == mobile_selected)[0].title })}>
                                                <h6 className="mb-0 mt-0" style={{ fontWeight: 400 }}>{child.name}</h6>
                                                <input type='checkbox' checked={selected_items.includes(child.name) ? true : false} />
                                            </div>
                                        )
                                    })
                                }







                            </div>

                            {
                                isMobile &&
                                <div className="mobile_version_filters_bottom">
                                    <div className="clear_All" onClick={clear_all}>Clear All</div>
                                    <div className="apply_now" onClick={apply_all}>Apply Now</div>
                                </div>
                            }

                        </div>
                    </Modal.Body>
                </Modal>

                {/* mobile filters ends here */}


                {/* mobile sort by starts here */}
                <Modal show={sort_show} className="mobile_filter_modal sort_by_modal" onHide={handleClose} centered >
                    <div className="filter_header border-bottom p-3">
                        <h4 className="mb-0 mt-0">Sort By</h4>
                        <img src='/assets/vector_icons/close.png' width={16} height={16} onClick={() => setsort_show(!sort_show)} />
                    </div>
                    <Modal.Body className="modal_body p-0">

                        <div className="modal_filter_body">
                            <div className="modal_filter_body_right_side p-0" style={{ width: '100%' }}>

                                {

                                    sort_byArray.map((child) => {
                                        return (
                                            <div className={`filter_item px-3 ${selected_items.includes(child.slug) && 'active-background'}`} onClick={(e) => handleSelectItem(e, 'sortby', { value: child.slug + "@" + 'sortby' })}>
                                                <h6 className={`mb-0 mt-0 ${selected_items.includes(child.slug) && 'primarycolor'}`} style={{ fontWeight: selected_items.includes(child.slug) ? 600 : 400 }}>{child.title}</h6>
                                                <input type='radio' checked={selected_items.includes(child.slug) ? true : false} name='sort_by' />
                                            </div>
                                        )
                                    })
                                }







                            </div>
                        </div>
                    </Modal.Body>

                </Modal>
                {/* mobile sort by ends here */}
            </Container>
            {/* bottom sort by and filtewrs buttons for mobiles */}
            {
                isMobile &&
                <div className="mobile_version_filters_bottom">
                    <div className="button_1_mobile_filter border-right" ><img src="/assets/vector_icons/swap.png" /><h6 className="mx-2 mb-0 mt-0" onClick={handleShowSort}>Sort By</h6></div>
                    <div className="button_1_mobile_filter"><img src="/assets/vector_icons/filter.png" /> <h6 className="mx-2 mb-0 mt-0" onClick={handleShow}>Filter</h6></div>
                </div>
            }

        </>
    )
}

export default memo(ProductCategory);